import { Card, CardContent, Container, Grid, MenuItem, TextField, Typography } from "@material-ui/core";
import { useKiosk } from "application/contexts/kiosk/KioskContext";
import { useUi } from "application/contexts/ui/UIContext";
import BottomModal from "components/bottomModal/BottomModal";
import { PassKeyboard } from "components/passKeyboard/PassKeyboard";
import enviroment from "corss-cutting/enviroment";
import React, { useCallback, useState } from "react";
import { useAdmin } from "../../../application/contexts/admin/adminContext";
import styles from "./AuthOperator.module.scss"

export const AuthOperator = () => {
  const { operators, setOperator } = useAdmin();
  const { toast } = useUi();
  const { kiosk } = useKiosk();

  const [operatorId, setoperatorId] = useState<string | null>(null);
  const [deviceSerial] = useState<string>("");
  const [appVersion] = useState<string>("");

  const onPressLogin = useCallback(
    (valid: boolean) => {
      if (valid && operatorId) {
        setOperator(operatorId);
      } else {
        toast("Senha incorreta", "error");
      }
    },
    [setOperator, operatorId, toast]
  );

  return (
    <Container
      style={{
        padding: "16px 32px 24px",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 8,
      }}
    >
      <Grid spacing={2} container>
        <Card variant="outlined" className={styles.infoCard}>
          <CardContent className={styles.infoCardContent}>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">PDV</Typography>
              <Typography variant="body1">{kiosk?.profilerNamePDV ?? "—"}</Typography>
            </div>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">Patrimônio</Typography>
              <Typography variant="body1">{kiosk?.kioskName ?? "—"}</Typography>
            </div>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">Versão CefSharp</Typography>
              <Typography variant="body1">{kiosk?.cefsharpVersion ?? "—"}</Typography>
            </div>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">Versão</Typography>
              <Typography variant="body1">{kiosk?.reactVersionTotem ?? "—"}</Typography>
            </div>
          </CardContent>
        </Card>

        <TextField
          fullWidth
          value={operatorId ?? ""}
          select
          label="Selecione o operador"
          onChange={(e) => setoperatorId(e.target.value)}
          name={"operator"}
          variant="outlined"
          className={styles.select}
        >
          {operators.length ? (
            operators.map((operator) => (
              <MenuItem key={operator.id} value={operator.id}>
                {operator.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="">Aguarde...</MenuItem>
          )}
        </TextField>

        <BottomModal
          showModal={!!operatorId}
          onClickClose={() => setoperatorId(null)}
        >
          <div className={"drawer-paymentCashless"}>
            <h2>{`${
              operators.find((it) => it.id === operatorId)?.name ?? "Operador"
            }, entre com sua senha.`}</h2>
            <PassKeyboard
              onValidate={onPressLogin}
              password={
                operators.find((operator) => operator.id === operatorId)
                  ?.password ?? "xxx"
              }
            />
          </div>
        </BottomModal>
      </Grid>
      <div className={styles.version}>
        {kiosk?.localName && <span>{kiosk.localName}</span>}
        {kiosk?.kioskName && <span>{kiosk.kioskName}</span>}
        <span>{enviroment.appVersion}</span>
      </div>
      {(deviceSerial || appVersion) && (
        <div className={styles.serial}>
          {deviceSerial && `Serial: ${deviceSerial}`}
          {deviceSerial && appVersion && " - "}
          {appVersion && `App Version: v${appVersion}`}
        </div>
      )}
    </Container>
  );
};
